import {
  Box,
  Paper,
  Stack,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import _ from 'lodash';
import {
  PrimaryButton,
  TableButton,
} from '../../../components/style/ButtonStyle';
import {
  MaxWidthCell,
  PrettyScrollbarTableWrap,
  PrimaryBorderTable,
} from '../../../components/style/TableStyle';
import { FormTitle } from '../../../components/style/TextStyle';
import { AddButtonIcon } from '../../../layouts/dashboard/nav/IconButton';

import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import Empty from '../../../components/common/Empty';
import { useAuthAxios } from '../../../hooks/useAuthAxios';
import useResponsive from '../../../hooks/useResponsive';
import { useYupValidationResolver } from '../../../hooks/useYupValidationResolver';
import { CategoryTypeList, CategoryTypeListLabel } from '../../../utils/enum';
import { fDate } from '../../../utils/formatTime';
import AddCategoryButton from './Common/AddCategoryButton';
import { CreateTypeForm } from './Common/CreateCategoryForm';
import { typeDefaultValue, typeSchema } from './Common/DefaultValuesAndSchema';
import DeleteCategoryButton from './Common/DeleteButton';
import EditCategoryButton from './Common/EditCategoryButton';
import { EditTypeForm } from './Common/EditCategoryForm';
import { typeHeader } from './header';

export default function TypeCategory() {
  const mdUp = useResponsive('up', 'md');
  const navigate = useNavigate();
  const [getCategoriesResult, getCategories] = useAuthAxios(
    {
      method: 'GET',
      url: '/api/v1/category',
    },
    { manual: false },
  );
  const categories = _.get(getCategoriesResult, 'response.data');

  useEffect(() => {
    getCategories();
  }, [getCategories]);

  const resolver = useYupValidationResolver(
    Yup.object().shape({
      ...typeSchema,
    }),
  );

  const form = useForm<any>({
    mode: 'onTouched',
    resolver,
    defaultValues: {
      ...typeDefaultValue,
    },
    shouldUnregister: false,
  });

  const [postCategoryResult, postCategory] = useAuthAxios({
    method: 'POST',
    url: '/api/v1/category',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  const onSubmitCreateForm = form.handleSubmit(function (values) {
    const data = new FormData();
    data.append('categoryId', values.categoryId);
    data.append('categoryType', values.categoryType);
    data.append('title', values.title);
    data.append('notes', values.notes);
    data.append('file', values.file);

    postCategory({ data });
  });

  return (
    <Stack>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        {mdUp ? <FormTitle>구분 목록</FormTitle> : <Box />}
        {mdUp ? (
          <AddCategoryButton
            label="구분 추가"
            form={form}
            onSubmit={onSubmitCreateForm}
            children={<CreateTypeForm form={form} />}
            postResult={postCategoryResult}
            getResult={getCategories}
          />
        ) : (
          <Stack>
            <PrimaryButton
              onClick={() => navigate(`/category/type/form`)}
              startIcon={<AddButtonIcon />}
            >
              구분 추가
            </PrimaryButton>
            <Box />
          </Stack>
        )}
      </Stack>
      {_.isEmpty(categories) ? (
        <Empty sx={{ mt: '16px !important' }} />
      ) : (
        <PrettyScrollbarTableWrap>
          <TableContainer
            component={Paper}
            sx={{ mt: '16px !important', maxHeight: '506px' }}
          >
            <PrimaryBorderTable sx={{ minWidth: 910 }} size="small">
              <TableHead>
                <TableRow>
                  {_.map(typeHeader, t => (
                    <TableCell align="center" key={t.id}>
                      {t?.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {_.map(categories, category => {
                  const isEquipement =
                    _.get(category, 'categoryType') ===
                    CategoryTypeList.OUTDOOR_GYM_EQUIPMENT;
                  const isDefault = _.get(category, 'title') === '기타';
                  const isUnDeletable = isEquipement || isDefault;
                  return (
                    <TableRow key={category.categoryId}>
                      <TableCell align="center">
                        {category?.title || '-'}
                      </TableCell>
                      <TableCell align="center">
                        {_.get(
                          CategoryTypeListLabel,
                          category?.categoryType,
                          '-',
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {fDate(category?.updatedAt, 'yyyy-MM-dd') || '-'}
                      </TableCell>
                      <TableCell align="center">
                        <Stack direction="row" justifyContent="center">
                          <img
                            alt="marker"
                            style={{ maxWidth: 44 }}
                            src={_.get(category, 'iconUrl')}
                          />
                        </Stack>
                      </TableCell>
                      <MaxWidthCell align="center">
                        {category?.notes || '-'}
                      </MaxWidthCell>
                      <TableCell align="center">
                        {mdUp ? (
                          <EditCategoryButton
                            label="구분 수정"
                            form={form}
                            children={
                              <EditTypeForm
                                form={form}
                                categoryId={category?.categoryId}
                              />
                            }
                            category="category"
                            categoryId={category?.categoryId}
                            getResult={getCategories}
                          />
                        ) : (
                          <TableButton
                            onClick={() => {
                              navigate(
                                `/category/type/${category?.categoryId}/form`,
                              );
                            }}
                          >
                            수정
                          </TableButton>
                        )}
                      </TableCell>

                      <TableCell align="center">
                        {isUnDeletable ? (
                          <></>
                        ) : (
                          <DeleteCategoryButton
                            category="category"
                            categoryId={category?.categoryId}
                            getResult={getCategories}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </PrimaryBorderTable>
          </TableContainer>
        </PrettyScrollbarTableWrap>
      )}
    </Stack>
  );
}
